import { Radio, Text } from '@nimbus-ds/components';
import { FormField } from '@nimbus-ds/patterns';
import { Stack } from 'commons/components';
import { OptionSection as OptionSectionType } from '../shared/types';

type OptionsSectionProps = Readonly<OptionSectionType>;

function OptionsSection({
  title,
  name,
  options,
  value,
  onChange,
  renderConditional,
}: OptionsSectionProps): JSX.Element {
  return (
    <Stack column align="stretch" spacing="tight">
      {!!title && (
        <Stack.Item>
          <Text>{title}</Text>
        </Stack.Item>
      )}
      <Stack.Item>
        <FormField>
          <Stack spacing="tight">
            {options.map((option) => (
              <Radio
                key={option.value}
                id={`${name}-${option.value}`}
                label={option.label}
                name={name}
                value={option.value}
                onChange={onChange}
                as="button"
                checked={value === option.value}
                disabled={option.disabled}
              />
            ))}
          </Stack>
        </FormField>
      </Stack.Item>
      {renderConditional && !!value && (
        <Stack.Item>{renderConditional(value)}</Stack.Item>
      )}
    </Stack>
  );
}

export default OptionsSection;
